// src/lib/debugLog.ts
// Debug logging gated by localStorage flag `l2f_debug`.
// Set `localStorage.setItem('l2f_debug', 'true')` and reload to enable.
// Flag is read once at module init for performance.
const enabled = (() => {
  try {
    return typeof localStorage !== "undefined" && localStorage.getItem("l2f_debug") === "true";
  } catch {
    return false;
  }
})();

export const debugLog: (...args: unknown[]) => void = enabled
  ? console.log.bind(console)
  : () => {};

export const debugWarn: (...args: unknown[]) => void = enabled
  ? console.warn.bind(console)
  : () => {};
